// extracted by mini-css-extract-plugin
export default {"error_alert_icon":"error-alert_error_alert_icon__U+xyz","error_alert_btn":"error-alert_error_alert_btn__iy+MW"};